import type { MainNavigationItem } from "./client";

const CONSULTANT_LINK = "poc_nav_3_navigation_consultant_link_only";

function isForEveryone(item: { contentType?: string }): boolean {
	return item.contentType !== CONSULTANT_LINK;
}

export function navigationFor(
	items: MainNavigationItem[],
	isConsultant: boolean
): MainNavigationItem[] {
	if (isConsultant) return items;
	return items
		.filter(isForEveryone)
		.map((item) =>
			"reference" in item
				? { ...item, reference: item.reference.filter(isForEveryone) }
				: item
		);
}
